import { jsxs as d, jsx as r } from "react/jsx-runtime";
import m from "./index.es2343.js";
import { EmptyStateIllustration as l } from "./index.es463.js";
import { Heading as p } from "./index.es489.js";
import { BodyText as c } from "./index.es487.js";
import { Button as f } from "./index.es11.js";
const R = ({
  title: a,
  message: e,
  testId: o,
  buttonText: t,
  buttonVariant: s = "primary-brand",
  illustration: i,
  onButtonClick: n
}) => /* @__PURE__ */ d("div", { className: m.noRowsContainer, "data-testid": o, children: [
  /* @__PURE__ */ r("div", { className: m.noRowsIllustration, children: i || /* @__PURE__ */ r(l, { size: 400 }) }),
  /* @__PURE__ */ r(p, { variant: "h4", children: a }),
  /* @__PURE__ */ r(c, { children: e }),
  t && n && /* @__PURE__ */ r(f, { variant: s, onClick: n, testId: `${o}-button`, children: t })
] });
export {
  R as NoRowsComponent
};
//# sourceMappingURL=index.es539.js.map
